import React, { ReactNode, DetailedHTMLProps, memo } from "react";

import "./contentContainer.scss";
import Loading from "../../components/loading/loading";
export interface ContentContainerProps
  extends DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  title?: string;
  titleComponent?: ReactNode;
  header?: ReactNode;
  componentHeader?: ReactNode;
  isLoading?: boolean;
}

const ContentContainer: React.FC<ContentContainerProps> = memo(({
  title,
  titleComponent,
  header,
  componentHeader,
  isLoading,
  ...props
}) => {
  return (
    <div className="xgs-site__content-container" {...props}>
      {titleComponent}
      {!titleComponent && (
        <>
          <span>{title}</span>
          <Loading isLoading={isLoading} />
        </>
      )}
      <div className="xgs-site__content-container__component">
        <div className="xgs-site__content-container__header">
          {header}
        </div>
        <div className="xgs-site__content-container__body">
          {props.children}
        </div>
        <div className="xgs-site__content-container__bottom"></div>
      </div>
    </div>
  );
});

export default ContentContainer;